import axios from '../../http.service';
import * as TYPES from '../Enums/Script.Allocation.Enums';

export const getScriptAllocationCount = (appointmentTypes, year) => {
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/scripts/allocation/count/${year}/${JSON.stringify(appointmentTypes)}`);

			return resp.status === 200
				? dispatch({
						type: TYPES.SCRIPT_ALLOCATION_COUNT,
						payload: resp.data
				  })
				: dispatch({
						type: TYPES.SCRIPT_ALLOCATION_ERROR,
						payload: resp.data
				  });
		} catch (error) {
			dispatch({
				type: TYPES.SCRIPT_ALLOCATION_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching Template Count Data', error.message]
				}
			});
		}
	};
};

export const getScriptAllocationData = (appointmentTypes, year, query, exportData = false) => {
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/scripts/allocation/${year}/${JSON.stringify(appointmentTypes)}?pagination=${JSON.stringify(query)}`);

			return resp.status === 200
				? dispatch({
						type: !exportData ? TYPES.SCRIPT_ALLOCATION_GET : TYPES.SCRIPT_ALLOCATION_GET_ALL,
						payload: resp.data
				  })
				: dispatch({
						type: TYPES.SCRIPT_ALLOCATION_ERROR,
						payload: resp.data
				  });
		} catch (error) {
			dispatch({
				type: TYPES.SCRIPT_ALLOCATION_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching Template Data', error.message]
				}
			});
		}
	};
};

export const clearAllScriptAllocationUpdates = () => dispatch => dispatch({ type: TYPES.SCRIPT_ALLOCATION_CLEAR_ALL_UPDATES, payload: {} });
